<template>
  <div>
    <!-- <h1>Tabela de ocorrências de/para</h1>
    <br />-->
    <h1>Tabela PROCEDA</h1>

    <!-- <b-row>
      <b-col sm="6" md="6" lg="6">
        <b-form-group
          label="Per page"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>-->

    <b-row>
      <b-table
        ref="selectableTable"
        id="table-tabela-proceda"
        hover
        :items="itemsTabelaProceda"
        :fields="fieldsTabelaProceda"
        :per-page="perPage"
        :current-page="currentPage"
        selectable
        :select-mode="selectModeTabelaProceda"
        @row-selected="onRowSelected"
      >
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <!-- <template v-slot:cell(id)="data">
        <router-link :to="'/usuario/edit/' + data.value">{{ data.value }}</router-link>
        </template>-->
      </b-table>
    </b-row>

    <b-row>
      <b-col sm="4" md="4" lg="4">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        ></b-pagination>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <label
          for="perPageSelect"
        >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{rows}}</label>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <b-row>
          <b-col sm="3" md="3" lg="3">
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-col>
          <b-col style="padding-left: 0px;">
            <label for="perPageSelect">registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <p>
      Selected Rows:
      <br />
      {{ selectedTabelaProceda }}
    </p>-->

    <br />
    <div v-if="!selectedTabelaProceda.length">
      <base-alert type="primary">{{ $t("proceda.selecioneUmRegistro") }}</base-alert>
    </div>
    <div v-if="selectedTabelaProceda.length">
      <h1>Códigos de/para</h1>
      <div v-if="itemsDePara.length == 0">
        <base-alert type="primary">{{ $t("proceda.nenhumDePara") }}</base-alert>
      </div>
      <div v-if="itemsDePara.length > 0">
        <b-table id="table-de-para" hover :items="itemsDePara" :fields="fieldsDaPara">
          <!-- <template v-slot:cell(id)="data">
        <router-link :to="'/usuario/edit/' + data.value">{{ data.value }}</router-link>
          </template>-->

          <template v-slot:cell(codigo)="row">
            <b-form-input
              type="text"
              placeholder="Código"
              v-model="row.item.codigo"
              v-mask="'999999999'"
              v-on:change="onDataChange(row.item)"
            />
          </template>
          <template v-slot:cell(descricao)="row">
            <b-form-input
              type="text"
              placeholder="Descrição"
              v-model="row.item.descricao"
              v-on:change="onDataChange(row.item)"
            />
          </template>
        </b-table>
      </div>
      <b-button v-b-modal.modal-prevent-closing>Novo código</b-button>
      <b-modal
        id="modal-prevent-closing"
        ref="modal"
        title="Novo código"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
            :state="formModal.nameState"
            label="Código"
            label-for="input-codigo"
            invalid-feedback="Código é obrigatório"
          >
            <b-form-input
              type="text"
              id="input-codigo"
              placeholder="Código"
              v-model="formModal.codigo"
              :state="formModal.nameState"
              required
              v-mask="'999999999'"
            />
          </b-form-group>
          <b-form-group
            label="Descrição"
            label-for="input-descricao"
          >
            <b-form-input
              type="text"
              id="input-descricao"
              placeholder="Descrição"
              v-model="formModal.descricao"
            />
          </b-form-group>
        </form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import { BaseAlert } from "src/components";

export default {
  name: "List",
  components: {
    BaseAlert,
  },
  data: function () {
    return {
      fieldsTabelaProceda: [
        {
          label: "Selecionado",
          key: "selected",
        },
        // {
        //   key: "id",
        //   sortable: true
        // },
        {
          label: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          label: "Descrição",
          key: "descricao",
          sortable: true,
        },
      ],
      fieldsDaPara: [
        // {
        //   key: "id",
        //   sortable: true
        // },
        {
          label: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          label: "Descrição",
          key: "descricao",
          sortable: true,
        },
      ],
      formModal: {
        codigo: 0,
        nameState: null,
        descricao: '',
      },
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
        data: {
          codigo: null,
        },
      },
      itemsTabelaProceda: [],
      itemsDePara: [],
      perPage: 5,
      pageOptions: [5, 10, 25, 50, 100, 150],
      currentPage: 1,
      selectModeTabelaProceda: "single",
      selectedTabelaProceda: [],
    };
  },
  computed: {
    rows() {
      return this.itemsTabelaProceda.length;
    },
    paginationFrom() {
      return this.perPage * (this.currentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.perPage;
      if (to > this.rows) return this.rows;
      return to;
    },
  },
  created: function () {
    this.loadDataTabelaProceda();
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    async loadDataTabelaProceda() {
      this.$api
        .get("/tabelaOcorrenciaProceda")
        .then((response) => {
          this.itemsTabelaProceda = response.data;
          this.selectFistRow();
        })
        .catch((error) => {
          this.itemsTabelaProceda = [];
          this.selectFistRow();
        });
    },
    async loadDataDePara() {
      if (this.selectedTabelaProceda.length > 0) {
        this.$api
          .get(
            "/ocorrenciaDeParaVM/empresa/proceda/" +
              this.selectedTabelaProceda[0].id.toString()
          )
          .then((response) => {
            this.itemsDePara = response.data;
          })
          .catch((error) => {
            this.itemsDePara = [];
          });
      } else {
        this.itemsDePara = [];
      }
    },
    selectFistRow() {
      this.$refs.selectableTable.selectRow(0);
    },
    onDataChange(item) {
      if (item.codigo) {
        item.codigo = parseInt(item.codigo);
        item.descricao = item.descricao;

        this.$api
          .post("/ocorrenciaDeParaVM/edit/" + item.id.toString(), item)
          .then((response) => {
            console.log("Registro alterado");
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 400) {
              if (error.response.data) {
                console.log(error.response.data.errors);
              }
            }
          });
      }
    },
    onRowSelected(items) {
      this.selectedTabelaProceda = items;
      this.loadDataDePara();
    },

    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.formModal.nameState = valid;
      return valid;
    },
    resetModal() {
      this.formModal.codigo = 0;
      this.formModal.descricao = '';
      this.formModal.nameState = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }

      if (this.selectedTabelaProceda.length > 0) {
        this.$api
          .post("/ocorrenciaDeParaVM/create", {
            tabelaOcorrenciaProcedaId: this.selectedTabelaProceda[0].id,
            codigo: parseInt(this.formModal.codigo),
            descricao: this.formModal.descricao,
          })
          .then((response) => {
            console.log("Registro criado");
            this.itemsDePara.push(response.data);

            this.$nextTick(() => {
              this.$bvModal.hide("modal-prevent-closing");
            });
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 400) {
              if (error.response.data) {
                console.log(error.response.data.errors);
              }
            }
            this.$nextTick(() => {
              this.$bvModal.hide("modal-prevent-closing");
            });
          });
      }
    },
    // selectAllRows() {
    //   this.$refs.selectableTable.selectAllRows();
    // },
    // clearSelected() {
    //   this.$refs.selectableTable.clearSelected();
    // },
    // selectThirdRow() {
    //   // Rows are indexed from 0, so the third row is index 2
    //   this.$refs.selectableTable.selectRow(2);
    // },
    // unselectThirdRow() {
    //   // Rows are indexed from 0, so the third row is index 2
    //   this.$refs.selectableTable.unselectRow(2);
    // }
  },
};
</script>

